<template lang="pug">
.new-set
  shForm(title="Nuevo Set")
</template>

<script>
import shForm from '@/components/pages/set/Form'

export default {
  name: 'NewSet',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-set
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/set/New.vue